import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { KeycloakAuthService } from '../services/keycloak/keycloak-auth.service';
export const browserAuthGuard: CanActivateFn = async (_route, state) => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const keycloakAuthService = inject(KeycloakAuthService);

  try {
    const isAuthenticated = await keycloakAuthService.initialize();
    if (isAuthenticated) {
      return true;
    }

    keycloakAuthService.setPostLoginRedirectUrl(state.url);
    try {
      // First try silent SSO check (prompt=none).
      // If a Keycloak session exists, this redirects to Keycloak and back
      // without showing a login form, establishing the KEYCLOAK_SESSION cookie.
      // If no session exists, Keycloak returns with error=login_required,
      // which the callback component handles by calling login() interactively.
      await keycloakAuthService.login({ prompt: 'none' });
      return false;
    } catch {
      await keycloakAuthService.login();
      return false;
    }
  } catch {
    return false;
  }
};
